import { render } from "./MyWalletBalance.vue?vue&type=template&id=139d7b3e"
import script from "./MyWalletBalance.vue?vue&type=script&lang=js"
export * from "./MyWalletBalance.vue?vue&type=script&lang=js"

import "./MyWalletBalance.vue?vue&type=style&index=0&id=139d7b3e&lang=css"

import exportComponent from "/codebuild/output/src338202144/src/web-app-vue-3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__